module.exports = require('./dist/ReactCrop');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-crop/index.js
// module id = 20
// module chunks = 0